
  import Vue from 'vue'
  import SetpointService from '@/services/SetpointService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'SetpointDeleteDialog',
    props: ['setpoint'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        SetpointService.deleteSetpoint(this.$root.$store.state.session.selectedTenant.uuid, this.setpoint.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('setpoint.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            this.setpoint.state = "deprecated";

            setTimeout(() => { 
                this.$emit("delete", this.setpoint);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('setpoint.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
